<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="`faq-${id}`">
      <button class="accordion-button" :class="(isVisible) ? `` : `collapsed`" type="button" data-bs-toggle="collapse" :data-bs-target="`#faq-collapse${id}`" :aria-expanded="isVisible" :aria-controls="`faq-collapse${id}`">
        <div class="f17-l19-m text-right">{{q}}</div>
      </button>
    </h2>
    <div :id="`faq-collapse${id}`" class="accordion-collapse collapse" :class="(isVisible) ? `show` : ``" :aria-labelledby="`faq-${id}`">
      <div class="accordion-body">
        <div class="f16-l21 red-link" v-html="a"></div>
        <div class="f16-l21 red-link" v-if="a2" v-html="a2"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    idx: Number,
    q: String,
    a: String,
    a2: String,
    show: Boolean,
  },
  data() {
    return {
      id : 0,
      isVisible: this.show // Create a local reactive property
    }
  },
  mounted() {
    this.id =  this.id = this.$props.id || this.$.uid;
  },
  watch: {
    show(newVal) {
      this.isVisible = newVal; // Sync prop changes
    }
  },
  methods: {
    toggle() {
      this.isVisible = true;
      // this.$emit("update:show", this.isVisible); // Emit event to parent
    }
  }
}
</script>